<template>
	<div class="Toolbar-group" :class="classes">
		<!-- @slot Toolbar item -->
		<slot />
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {};
	},
	props: {
		align: String,
		divider: Boolean,
		bottom: Boolean,
	},
	computed: {
		classes: function () {
			return {
				'Toolbar-group--right': this.align === 'right',
				'Toolbar-group--divider': this.divider,
				'Toolbar-group--fixedToBottom': this.bottom,
			};
		},
	},
};
</script>
